import { ChrSideNavDirective } from '@ciphr-design-system/angular';

import { NavigationBrandingLevel } from '@ciphr/core/app-branding';

export const navigationPalettesMap = new Map<NavigationBrandingLevel, ChrSideNavDirective['palette']>([
  ['High', 'accent'],
  ['Low', 'neutral'],
  ['Medium', 'accent-neutral'],
]);
